export const blockIconsContentInventory = (
	<span className='material-symbols-outlined'>inventory</span>
);
